module.exports = __webpack_public_path__ + "static/media/ok-hand-icon.348b456b.png";